import { render, staticRenderFns } from "./labelForm.vue?vue&type=template&id=720aa056&scoped=true"
import script from "./labelForm.vue?vue&type=script&lang=js"
export * from "./labelForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720aa056",
  null
  
)

export default component.exports